import {
  Card,
  ICON_LINK,
  Message, Spacing,
  Text,
} from '@doveit/bricks';
import React from 'react';
import useRBAC from '../../../hooks/use-rbac/useRBAC';
import { slugIt } from '../../../utils/string';
import CopyLink from '../../containers/copy-link/CopyLink';
import buildTrackedLink from '../../utils/build-tracked-link/buildTrackedLink';
import SimplePageLayout from '../../../layouts/simple-page-layout/SimplePageLayout';

export const AGENT_PERSONAL_PAGE_INFO_MESSAGE = 'Prima di utilizzare l\'url controlla l\'esistenza della pagina. Se la pagina non è raggiungibile probabilmente devi ancora fornire foto e biografia al tuo responsabile.';

const CreateTrackedLinksPage: React.FC = () => {
  const { user } = useRBAC();

  return user! && (
    <SimplePageLayout>
      <Card paddingSize="M">
        <Card.Header
          icon={{ path: ICON_LINK }}
          title="Crea link tracciato"
        />
        <Card.Content>
          <Text.Body>
            Crea un link tracciato personalizzato e utilizzalo sui tuoi account social lavorativi in modo che possano esserti riconosciute le lead personali provenienti dalle tue campagne. Ricordati di controllare che il link sia funzionante.
          </Text.Body>
        </Card.Content>
        <Card.Divider />
        <Card.Content>
          <CopyLink
            data-ref="personal-page-link"
            label="Pagina personale"
            url={`https://www.dove.it/agenti-immobiliari/${slugIt(user.name)}`}
          />
          <Spacing margin={[150, 0, 0]}>
            <Message message={AGENT_PERSONAL_PAGE_INFO_MESSAGE} />
          </Spacing>
        </Card.Content>
        <Card.Divider />
        <Card.Content>
          <CopyLink
            data-ref="selling-property-link"
            label="Landing page vendita casa"
            url={buildTrackedLink('https://www.dove.it/l/vendita-casa', slugIt(user.name))}
            recommended
          />
        </Card.Content>
      </Card>
    </SimplePageLayout>
  );
};

export default CreateTrackedLinksPage;
